import * as React from "react";
import { createComponent } from "@lit-labs/react";
import Component from "../../components/Pagination/sgds-pagination";

customElements.define("sgds-pagination", Component);

export default createComponent({
  react: React,
  tagName: "sgds-pagination",
  elementClass: Component,
  events: {
    onSgdsPageChange: "sgds-page-change"
  }
});
